import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useRenameTestSession } from "@/hooks/useTestSessions";

type Props = {
  sessionId: string;
  currentLabel: string | null;
  open: boolean;
  onClose: () => void;
};

export function RenameTestSessionDialog({
  sessionId,
  currentLabel,
  open,
  onClose,
}: Props): React.JSX.Element {
  const rename = useRenameTestSession();
  const [label, setLabel] = useState(currentLabel ?? "");

  useEffect(() => {
    if (open) setLabel(currentLabel ?? "");
  }, [open, currentLabel]);

  const trimmed = label.trim();
  const invalid = trimmed.length === 0 || trimmed.length > 120;

  function handleSave(): void {
    if (invalid) return;
    rename.mutate(
      { id: sessionId, label: trimmed },
      {
        onSuccess: () => {
          toast.success("Prueba renombrada");
          onClose();
        },
        onError: (err) => toast.error(err.message ?? "Error al renombrar"),
      },
    );
  }

  return (
    <Dialog open={open} onOpenChange={(v: boolean) => !v && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Renombrar prueba</DialogTitle>
        </DialogHeader>
        <Input
          value={label}
          maxLength={120}
          autoFocus
          placeholder="Nombre de la prueba"
          onChange={(e) => setLabel(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSave();
          }}
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={rename.isPending}>
            Cancelar
          </Button>
          <Button onClick={handleSave} disabled={invalid || rename.isPending}>
            {rename.isPending ? "Guardando…" : "Guardar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
